<template>
  <cx-showcase-section :name="name" :link="link" class="cx-button-showcase">
    <div class="cxu-d-flex cxu-gap-10">
      <cx-date-time-picker
        v-model="selectedDate"
        :allowFutureDates="true"
        :minDate="minDate"
        label="Pick date and time!"/>
      <cx-date-time-picker
        v-model="selectedDate"
        :allowFutureDates="true"
        :events="events"
        label="Pick date and time, watch out for events!"/>
      <cx-date-time-picker
        v-model="selectedDate"
        :allowFutureDates="true"
        :events="events"
        label="Pick date and time, watch out for events in custom color!"/>
      <cx-date-time-picker
        v-model="selectedDate"
        :allowFutureDates="true"
        :minDate="minDate"
        label="Pick date and time (loading)!"
        :loading="true"/>
    </div>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxDateTimePicker from '@/components/datePickers/CxDateTimePicker';
import { startOfToday, startOfYesterday, sub } from 'date-fns';

export default {
  name: 'CxDatePickerShowcase',
  components: {
    CxShowcaseSection,
    CxDateTimePicker
  },
  data() {
    return {
      name: 'CxDateTimePicker',
      link: '',
      date: new Date(),
      minDate: sub(startOfToday(), { months: 1 }),
      events: [new Date(), startOfYesterday(), sub(new Date(), { days: 10 })]
    };
  },
  computed: {
    selectedDate: {
      get() { return this.date; },
      set(value) { this.date = value; }
    },
  }
};

</script>